<template>
  <div>
    <v-row :key="dataTableComponentKey">
      <v-col md="6" class="py-0">
        <span>
          <v-icon
            color="grey"
            small
            v-text="$getIcon('mdiInformationOutline')"
          ></v-icon>
        </span>
        <span class="subtitle-2 font-weight-bold mb-0">
          Quantity:
        </span>
        <v-text-field
          v-model="formValues.quantity"
          type="number"
          min="1"
          :error-messages="formValidator.getError('quantity')"
          label="Quantity"
        >
        </v-text-field>
      </v-col>
      <v-col md="6" class="py-0">
        <span>
          <v-icon
            color="grey"
            small
            v-text="$getIcon('mdiInformationOutline')"
          ></v-icon>
        </span>
        <span class="subtitle-2 font-weight-bold mb-0">
          Price:
        </span>
        <span v-if="formValues.vat > 0" class="caption grey--text">
          (Inclusive of VAT) </span
        ><span v-if="formValues.discount > 0" class="caption grey--text">
          (Inclusive of Discount)
        </span>
        <div class="font-weight-bold caption mt-5">
          <v-row>
            <v-col cols="9" class="py-0"
              >NRs.{{
                emitAmount(currencyConvert(calculateSalesAmount(formValues)))
              }}</v-col
            >
            <v-col cols="3" class="py-0"
              ><v-icon
                @click="updateSalesAchievement = true"
                v-text="$getIcon('mdiSquareEditOutline')"
              ></v-icon
            ></v-col>
          </v-row>
        </div>
        <hr class="mt-1" />
      </v-col>
      <v-dialog v-model="updateSalesAchievement" width="600px">
        <v-card tile>
          <vue-card-title
            :display-card.sync="updateSalesAchievement"
            :title="`Update Price`"
            :subtitle="'Update price of the service.'"
            :icon="$getIcon('mdiFileDocumentEdit')"
            closable
            @close="updateSalesAchievement = false"
          >
          </vue-card-title>
          <v-card-text>
            <v-row v-if="updateSalesAchievement">
              <v-col md="6">
                <v-text-field
                  v-model="formValues.quantity"
                  type="number"
                  min="1"
                  :error-messages="formValidator.getError('quantity')"
                  label="Quantity"
                >
                </v-text-field>
                <v-text-field
                  v-model="formValues.per_price"
                  :error-messages="formValidator.getError('per_price')"
                  label="Per Price"
                >
                </v-text-field>
                <v-text-field
                  v-model="formValues.vat"
                  :error-messages="formValidator.getError('vat')"
                  label="VAT (%)"
                  :mask="`##`"
                >
                </v-text-field>
                <h4 class="grey--text mb-2 text-center">
                  Select the applicable discount model.
                </h4>
                <v-radio-group v-model="formValues.discount_type" row>
                  <v-radio label="Percentage" value="percentage"></v-radio>
                  <v-radio label="Flat" value="flat"></v-radio>
                </v-radio-group>
                <v-text-field
                  v-model="formValues.discount"
                  :label="
                    formValues.discount_type === `percentage`
                      ? `Percentage (%)`
                      : `Flat Discount`
                  "
                  :mask="
                    formValues.discount_type === `percentage`
                      ? `##`
                      : `##########`
                  "
                >
                </v-text-field>
              </v-col>
              <v-col md="6">
                <div
                  v-for="(salesAmount, index) in [
                    calculateSalesAmount(formValues)
                  ]"
                  :key="index"
                  class="ma-3"
                >
                  <div class="d-flex">
                    <div class="text-left">
                      Amount :
                    </div>
                    <div class="text-right">
                      {{ salesAmount.initialPrice }}
                    </div>
                  </div>
                  <div class="d-flex">
                    <div class="text-left">
                      Discount
                      <small v-if="formValues.discount_type === `percentage`"
                        >(%)
                      </small>
                      <small v-else>(Flat)</small>
                      :
                    </div>
                    <div class="text-right">
                      {{ salesAmount.discountedPrice }}
                    </div>
                  </div>
                  <div class="d-flex">
                    <div class="text-left">
                      Total Amount (A-D) :
                    </div>
                    <div class="text-right">
                      {{ salesAmount.totalAmount }}
                    </div>
                  </div>
                  <div class="d-flex">
                    <div class="text-left">
                      VAT {{ formValues.vat }}% of TA :
                    </div>
                    <div class="text-right">
                      {{ salesAmount.vatAmount }}
                    </div>
                  </div>
                  <v-divider class="my-2"></v-divider>
                  <div class="d-flex my-2">
                    <div class="text-left font-weight-bold">
                      Total Invoicing Amount:
                    </div>
                    <div class="text-right font-weight-bold">
                      {{ salesAmount.invoiceAmount }}
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-row no-gutters>
              <v-col align="right">
                <v-btn @click="updateSalesAchievement = false" class="primary">
                  Update
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    selectedService: {
      type: Object,
      required: true
    },
    formValidator: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dataTableComponentKey: 1,
      formValues: this.getFormValues(),
      updateSalesAchievement: false
    };
  },
  watch: {
    "formValues.quantity"(val) {
      this.$emit("updateQuantity", val);
    },
    selectedService() {
      this.formValues = this.getFormValues();
    }
  },
  methods: {
    currencyConvert(n) {
      // return n ? n.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,") : "";
      return n;
    },
    decreaseServiceQuantity() {
      const service = this.selectedServiceData;
      service.sales_achievement.quantity =
        service.sales_achievement.quantity - 1;
      this.dataTableComponentKey += 1;
    },
    increaseServiceQuantity() {
      const service = this.selectedServiceData;
      service.sales_achievement.quantity =
        service.sales_achievement.quantity + 1;
      this.dataTableComponentKey += 1;
    },
    calculateSalesAmount(salesAchievementData) {
      // returns final price after vat / tax and discount
      const initialPrice =
        salesAchievementData.quantity * salesAchievementData.per_price;
      let discountedPrice = 0;
      if (salesAchievementData.discount_type === "percentage") {
        discountedPrice = (salesAchievementData.discount / 100) * initialPrice;
      } else {
        discountedPrice = salesAchievementData.discount;
      }
      const totalAmount = initialPrice - discountedPrice;
      const vatAmount = (salesAchievementData.vat / 100) * totalAmount;
      const invoiceAmount = totalAmount + vatAmount;
      return {
        initialPrice: salesAchievementData.per_price.toLocaleString(),
        discountedPrice: discountedPrice.toLocaleString(),
        totalAmount: totalAmount.toLocaleString(),
        vatAmount: vatAmount.toLocaleString(),
        invoiceAmount: invoiceAmount.toLocaleString()
      };
    },
    getFormValues() {
      return {
        achievementType: "Opportunity",
        quantity: this.selectedService.quantity || 1,
        per_price: this.selectedService.per_price,
        discount_type: "percentage",
        discount: 0,
        vat: 13,
        total: 0,
        remarks: ""
      };
    },
    emitAmount(amountCalc) {
      this.$emit("updatePrice", amountCalc.totalAmount);
      return amountCalc.totalAmount;
    }
  }
};
</script>

<style scoped></style>
